<template>
  <div
    class="flex w-full items-center justify-between"
    style="position: relative;"
  >
    <div class="w-full flex justify-start items-center">
      <vx-tooltip-with-slot-text
        position="bottom"
        v-if="params.roles.length > 1"
      >
        <!-- ホバー時に表示するツールチップ -->
        <template v-slot:text>
          <div v-for="role in params.roles" :key="role.id">
            <div class="aisea-text-14-400-white py-1  ">
              <div class="font-bold">{{ role.name }}</div>
              <div class="ml-2">
                {{ getDateString(role.startOn) }} ~
                {{ getDateString(role.endOn) }}
              </div>
            </div>
          </div>
        </template>
        <!-- ホバー対象 -->
        <template v-slot:inner>
          <p
            @click="onClickRoleLink"
            class="link-string ellipsis cursor-pointer whitespace-normal"
          >
            {{ roleString }}
          </p>
        </template>
      </vx-tooltip-with-slot-text>
      <p
        @click="onClickRoleLink"
        class="link-string ellipsis  cursor-pointer whitespace-normal"
        v-else
      >
        {{ roleString }}
      </p>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
import moment from "moment-timezone";
export default {
  name: "CellRendererHeaderRole",
  mixins: [ColorMixin],
  components: {
    VxTooltipWithSlotText,
  },
  computed: {
    roleString() {
      if (this.params.roles.length === 0) return "";
      return (
        this.params.roles[this.params.roles.length - 1].name +
        (this.params.roles.length > 1
          ? ` +${this.params.roles.length - 1}`
          : "")
      );
    },
  },
  methods: {
    onClickRoleLink() {
      const routeData = this.$router.resolve({
        name: "enterprise-management-crew-operator-crew-labor-detail",
        params: { id: this.params.id },
      });
      window.open(routeData.href, "_blank");
    },
    getDateString(date) {
      return moment(date).format("YYYY/MM/DD");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.link-string {
  color: $aisea-blue;
}
</style>
